import jQuery from 'jquery';
let $ = jQuery;

/**
* new HSN.QuantitySelector(config)
* A widget for selecting quantity with - and + buttons to interact with it
* - config (Object): A configuration object for the [[HSN.QuantitySelector]]
*   consisting of the following keys:
*   - application (HSN.Application): An instance of the [[HSN.Application]] that the QuantitySelector should interact with.
*   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the QuantitySelector.
**/
HSN.QuantitySelector = function(config) {
    var scope = this;

    scope.application = config.application;
    scope.container = $(config.container);
    scope.minusButton = scope.container.find('.minus');
    scope.plusButton = scope.container.find('.plus');
    scope.input = scope.container.find('.qs-quantity');

    var data = scope.container.data();

    scope.minQty = data.minQty;
    scope.maxQty = data.maxQty;
    scope.currentQty = data.currentQty;

    scope.minusButton.on('click', scope.Decrement.bind(scope));
    scope.plusButton.on('click', scope.Increment.bind(scope));

    scope.input.on('keydown', (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    });

    scope.RefreshUI();
};

HSN.QuantitySelector.prototype = {
    Increment: function() {
        var scope = this;
        scope.currentQty += 1;
        if (scope.currentQty > scope.maxQty) {
            scope.currentQty = scope.maxQty;
        }
        scope.RefreshUI();
        scope.Changed();
    },
    Decrement: function() {
        var scope = this;
        scope.currentQty -= 1;
        if (scope.currentQty < scope.minQty) {
            scope.currentQty = scope.minQty;
        }
        scope.RefreshUI();
        scope.Changed();
    },
    RefreshUI: function() {
        var scope = this;
        scope.minusButton.prop('disabled', scope.currentQty <= scope.minQty);
        scope.plusButton.prop('disabled', scope.currentQty >= scope.maxQty);
        scope.input.val(scope.currentQty);
    },
    Changed: function() {
        var scope = this;
        scope.container.trigger('qtyChanged', scope.currentQty);
    },
    GetQuantity: function() {
        return this.currentQty
    },
}


// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/QuantitySelector.js